"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var material_1 = require("@mui/material");
var react_1 = __importDefault(require("react"));
var SnackDisplay = function (props) {
    return (react_1.default.createElement(material_1.Snackbar, { open: props.snack != null, autoHideDuration: 6000, onClose: props.handleClose, anchorOrigin: { vertical: "top", horizontal: "center" } },
        react_1.default.createElement(material_1.Alert, { onClose: props.handleClose, sx: { width: '100%' }, variant: "filled", color: props.color || "success" }, props.snack)));
};
exports.default = SnackDisplay;
